module.exports = __webpack_public_path__ + "assets/img/default_profile_photo.17391576.png";